import { privacy } from "@redotech/schema-privacy";
import {
  arrayEqual,
  Equal,
  objectEqual,
  stringEqual,
} from "@redotech/util/equal";
import * as z from "zod";
import {
  productAsVariantStrategyEqual,
  ProductAsVariantStrategySchema,
} from "./product-as-variant-strategy";

export const productsAsVariantsConfigurationEqual: Equal<ProductsAsVariantsConfiguration> =
  objectEqual<ProductsAsVariantsConfiguration>({
    collectionId: stringEqual,
    strategies: arrayEqual(productAsVariantStrategyEqual),
  });

export const ProductsAsVariantsConfigurationSchema = z.object({
  collectionId: z.string().meta({ privacy: privacy.nonPii }),
  strategies: z
    .array(ProductAsVariantStrategySchema)
    .meta({ privacy: privacy.structured }),
  createdAt: z.string().optional().meta({ privacy: privacy.nonPii }),
  lastSyncedAt: z.string().nullish().meta({ privacy: privacy.nonPii }),
});
export type ProductsAsVariantsConfiguration = z.infer<
  typeof ProductsAsVariantsConfigurationSchema
>;
